import { createContext, useContext } from 'react';

export type SprintLifecycleContextProps = {
	canEditSprint: boolean;
	canManageSprints: boolean;
	isAddSprintDatesButtonVisible: boolean;
	isCreateSprintButtonDisabled: boolean;
	isCompleteSprintButtonVisible: boolean;
	isCompleteSprintButtonDisabled: boolean;
	isSprintMenuVisible: boolean;
	isStartSprintButtonVisible: boolean;
	isStartSprintEnabled: boolean;
};

export const SprintLifecycleContext = createContext<SprintLifecycleContextProps | undefined>(
	undefined,
);

export const useSprintLifecycleContext = () => {
	const context = useContext(SprintLifecycleContext);

	if (!context) {
		throw new Error(
			'useSprintLifecycleContext must be used within a SprintLifecycleContext.Provider',
		);
	}

	return context;
};
